import {
  usePinInput
} from "./chunk-NREVNCPV.mjs";
import {
  createPinArray
} from "./chunk-GDLD2H2I.mjs";

// src/pin-input.tsx
import * as React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import Input from "@mui/material/InputBase";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
var PinInputLabel = styled(FormLabel)(({ theme }) => ({
  ...theme.typography.body2
}));
var PinInput = React.forwardRef(function PinInput2(props, ref) {
  var _a;
  const { label, helperText, InputLabelProps, FormHelperTextProps, isInvalid } = props;
  const { getInputProps, value, id } = usePinInput(props);
  const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
  const inputLabelId = label && id ? `${id}-label` : void 0;
  return /* @__PURE__ */ jsxs(FormControl, { error: isInvalid, children: [
    label != null && label !== "" && /* @__PURE__ */ jsx(PinInputLabel, { htmlFor: id, id: inputLabelId, ...InputLabelProps, children: label }),
    /* @__PURE__ */ jsx(Stack, { direction: "row", spacing: 1, mt: 0.5, children: createPinArray((_a = props.length) != null ? _a : 0, value).map((char, index) => /* @__PURE__ */ createElement(
      Input,
      {
        sx: (t) => ({
          ...getPintInputStyles(t)
        }),
        ...getInputProps({ index, value: char }, ref),
        key: `pin-input-${index}`
      }
    )) }),
    helperText && /* @__PURE__ */ jsx(FormHelperText, { id: helperTextId, ...FormHelperTextProps, children: helperText })
  ] });
});
PinInput.defaultProps = {
  oneTimeCode: true,
  placeholder: "",
  type: "alphanumeric",
  length: 4,
  manageFocus: true
};
function getPintInputStyles(t) {
  return {
    width: t.space["8"],
    input: {
      borderRadius: t.space["1"],
      padding: t.space["2"],
      textAlign: "center",
      border: "1px solid",
      borderColor: t.palette.v3.border.default,
      boxShadow: "none",
      [t.pseudos._hover]: {
        borderColor: t.palette.v3.border.hover,
        boxShadow: t.elevations.center.sm,
        [t.pseudos._disabled]: {
          borderColor: t.palette.v3.border.disabled
        },
        [t.pseudos._invalid]: {
          borderColor: t.palette.v3.border.critical
        }
      },
      [t.pseudos._disabled]: {
        borderColor: t.palette.v3.border.disabled
      },
      [t.pseudos._focus]: {
        borderColor: t.palette.v3.primary.default
      },
      [t.pseudos._invalid]: {
        borderColor: t.palette.v3.border.critical
      }
    }
  };
}

export {
  PinInput
};
